jQuery(function ($) {
  // On DOM loaded

  $(".manitoba-faq-entries [data-accordion-role=item]").each(function () {
    const $trigger = $("[aria-controls]", this);

    $trigger.click(function () {
      const $trigger = $(this);
      const $panel = $("#" + $trigger.attr("aria-controls"));
      const shouldOpen = $trigger.attr("aria-expanded") === "false";

      const $currentItem = $trigger.parents('[data-accordion-role="item"]');
      const $group = $currentItem.parents('[data-accordion-role="group"]');

      if ($group.length) {
        switch ($group.attr("data-accordion-behavior")) {
          case "single":
            if (shouldOpen) {
              const $otherItems = $('[data-accordion-role="item"]', $group).not(
                $currentItem
              );
              $otherItems.each(function () {
                const $otherTrigger = $("[aria-controls]", this);
                $otherTrigger.attr("aria-expanded", false);
                const $otherPanel = $(
                  "#" + $otherTrigger.attr("aria-controls")
                );
                $otherPanel.attr("hidden", "hidden");
              });
            }
            break;
          case "multiple":
          default:
            break;
        }
      }

      $trigger.attr("aria-expanded", shouldOpen);
      $panel.attr("hidden", shouldOpen ? false : "hidden");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'faq_interaction',
        'faq_action': shouldOpen ? 'open' : 'close',
        'faq_question': $trigger.text().trim()
      });
    });

    $trigger.keydown(function (event) {
      if (
        [
          "ArrowDown",
          "Down",
          "ArrowUp",
          "Up",
          "Home",
          "PageUp",
          "End",
          "PageDown",
        ].indexOf(event.key) === -1
      )
        return; // Pas besoin pour les autres touches

      const $trigger = $(this);
      const $currentItem = $trigger.parents('[data-accordion-role="item"]');
      const $group = $currentItem.parents('[data-accordion-role="group"]');
      if (!$currentItem.length || !$group.length) return;

      const $items = $('[data-accordion-role="item"]', $group);
      const currentIndex = $items.index($currentItem);
      let newIndex = -1;

      switch (event.key) {
        case "ArrowDown":
        case "Down": // IE/Edge specific
          newIndex = (currentIndex + 1) % $items.length;
          break;
        case "ArrowUp":
        case "Up": // IE/Edge specific
          newIndex = (currentIndex - 1 + $items.length) % $items.length;
          break;
        case "Home":
        case "PageUp":
          newIndex = 0;
          break;
        case "End":
        case "PageDown":
          newIndex = $items.length - 1;
          break;
        default:
          return; // Exit if not a navigation key
      }

      if (newIndex !== -1) {
        event.preventDefault();
        $("[aria-controls]", $items[newIndex]).focus();
      }
    });
  });
});
